import { ref } from 'vue'
import { baseUrl } from '@/core/utils'
import { useMenuMessage } from '../../messages/useMenuMessage'

export type MenuButtonProps = {
  id: string
  target: string
}

export function useMenuButton(props: MenuButtonProps) {
  const { id, target } = props
  const image = getMenuImage(id)
  const disabled = ref(false)
  const message = useMenuMessage(id)

  message.onEnableMenuCommand((payload: any) => {
    if (payload.id == id) {
      disabled.value = false
    }
  })

  message.onDisableMenuCommand((payload: any) => {
    if (payload.id == id) {
      disabled.value = true
    }
  })

  return {
    id,
    image,
    target,
    disabled,
  }
}

// -----------------------------------------------
function getMenuImage(id: string) {
  const [name, lang] = id.split('-')
  const menu = baseUrl(`/images/nav/${lang}/${name}.png`)
  const hilight = menu.replace('.png', '-a.png')
  return { menu, hilight }
}

// -----------------------------------------------
